export enum ReportTypes {
    Directorate = 1,
    Project,
    PartnerOrganisation
}